import React from 'react';
import { motion } from 'framer-motion';
import './LandingPage.css';
import home from '../../Assets/Home.png';
import thums from '../../Assets/Thumbs up.png';
import peep from '../../Assets/People.png';

const LandingPage = () => {
    return (
        <div className="w-full" id='landingPage'>

            {/* Hero Section */}
            <div className="h-screen bg-cover text-xl md:text-2xl back flex items-center justify-center flex-col relative">

                {/* Overlay */}
                <div className="bg-black/50 w-full h-full absolute z-0"></div>

                {/* Hero Text */}
                <div className="w-full h-full flex items-center justify-center px-4 md:px-0 z-10">
                    <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1 }}
                        className="text-center px-4"
                    >
                        <h1 className="text-white fira-sans-condensed-bold text-2xl sm:text-3xl md:text-5xl leading-snug md:leading-tight tracking-wide">
                            Business Consultant &
                            <br />
                            <span className="mt-2 md:mt-4 block">
                                Document Clearing Services
                            </span>
                        </h1>

                        <div className="mt-5 md:mt-8">
                            <a className="btn font-bold text-sm sm:text-base px-6 py-2" href="#Service">
                                Explore Services
                            </a>
                        </div>
                    </motion.div>
                </div>

                {/* Cards Section */}
                <div className="max-w-7xl mx-auto px-4 pb-16 md:pb-40 pt-6 md:pt-10 z-10">

                    <div className="grid gap-6 sm:gap-8 md:grid-cols-2 lg:grid-cols-3">

                        {/* Card 1 */}
                        <motion.div
                            initial={{ x: -100, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ duration: 1, delay: 0.5 }}
                            className="bg-black/60 p-4 sm:p-6 rounded-lg flex items-start text-[#cecece] flex-col sm:flex-row"
                        >
                            <img src={home} className="h-10 sm:h-12 opacity-90 mb-3 sm:mb-2" alt="24/7 Services" />
                            <div className="sm:ml-6">
                                <h3 className="text-lg sm:text-xl font-bold mb-2">24/7 Services</h3>
                                <p className="text-sm sm:text-base">
                                    We try our best to bring the customer the greatest service, so, you can place your trust.
                                </p>
                            </div>
                        </motion.div>

                        {/* Card 2 */}
                        <motion.div
                            initial={{ y: 100, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ duration: 1, delay: 0.7 }}
                            className="bg-black/60 p-4 sm:p-6 rounded-lg flex items-start text-[#cecece] flex-col sm:flex-row"
                        >
                            <img src={peep} className="h-10 sm:h-12 opacity-90 mb-3 sm:mb-2" alt="Great Support" />
                            <div className="sm:ml-6">
                                <h3 className="text-lg sm:text-xl font-bold mb-2">Great Support</h3>
                                <p className="text-sm sm:text-base">
                                    Our support ensures the best experience for you. Trust us with your needs.
                                </p>
                            </div>
                        </motion.div>

                        {/* Card 3 */}
                        <motion.div
                            initial={{ x: 100, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ duration: 1, delay: 0.9 }}
                            className="bg-black/60 p-4 sm:p-6 rounded-lg flex items-start text-[#cecece] flex-col sm:flex-row"
                        >
                            <img src={thums} className="h-10 sm:h-12 opacity-90 mb-3 sm:mb-2" alt="High Quality" />
                            <div className="sm:ml-6">
                                <h3 className="text-lg sm:text-xl font-bold mb-2">High Quality</h3>
                                <p className="text-sm sm:text-base">
                                    Melsha provides high-quality service, so you don't need to worry about the result.
                                </p>
                            </div>
                        </motion.div>

                    </div>
                </div>

            </div>

        </div>
    );
};

export default LandingPage;
